import React, { useCallback, useEffect, useRef, useState } from "react"
import { FaqSection } from "./types"
import classes from "./css/FaqPanelSections.module.css"
import classNames from "classnames"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
interface Props {
  sections: FaqSection[]
  onSelected: (category: FaqSection) => void
  selected: FaqSection | undefined
}
const getSelectedIndex = (
  sections: FaqSection[],
  selected: FaqSection | undefined
) => sections.findIndex((x) => selected?.id === x.id)

const FaqPanelSections = ({ sections, onSelected, selected }: Props) => {
  const [selectionBarOffset, setSelectionBarOffset] = useState({
    offset: 0,
    width: 0,
  })
  const selectedIndex = getSelectedIndex(sections, selected)
  const ref = useRef<HTMLInputElement | null>(null)
  // setBarOffset
  const measuredRef = useCallback((node: HTMLInputElement) => {
    if (node !== null) {
      ref.current = node
      // setBarOffset();
      // const sections = node.getBoundingClientRect().width
      const section = node.querySelectorAll(".section")[selectedIndex]
      setSelectionBarOffset({
        offset:
          section.getBoundingClientRect().left -
          node.getBoundingClientRect().left,
        width: section.getBoundingClientRect().width,
      })
    }
  }, [])
  useEffect(() => {
    if (ref.current != null) {
      const section = ref.current.querySelectorAll(".section")[selectedIndex]
      setSelectionBarOffset({
        offset:
          section.getBoundingClientRect().left -
          ref.current.getBoundingClientRect().left,
        width: section.getBoundingClientRect().width,
      })
    }
  }, [selected])
  return (
    <div ref={measuredRef} className={classes.container}>
      {sections.map((x, i) => (
        <div
          key={x.id}
          className={classNames(
            "section cursor-pointer px-3 pb-2",
            selectedIndex === i && "font-bold"
          )}
          // variant={isSelected(x) ? "default" : "outlined"}
          onClick={() => {
            onSelected(x)
          }}
        >
          <TwRichTextField value={x.title} />
        </div>
      ))}
      <div
        className="absolute bottom-0 left-0 h-1 transition-transform origin-left bg-primary"
        style={{
          width: 1,
          transform: `translateX(${selectionBarOffset.offset}px) scaleX(${selectionBarOffset.width})`,
        }}
      />
    </div>
  )
}

export default FaqPanelSections
